module.exports = __webpack_public_path__ + "img/search-white.d64f8fcf.png";